import React, { useState } from 'react';
import { withGoogleMap, GoogleMap, Marker, InfoWindow } from 'react-google-maps';
import { MarkerClusterer } from 'react-google-maps/lib/components/addons/MarkerClusterer';

import { DEFAULT_MAP_LOCATION } from 'utils/constants';
import { useFetchConstant } from 'utils/hooks/general';

import LocationCard from '../LocationCard/LocationCard';
import hostAvailablePropertyApproved from '../../images/Host_Available_Property_Approved.png';
import hostAvailablePropertyBanned from '../../images/Host_Available_Property_Banned.png';
import hostAvailablePropertyUnregulated from '../../images/Host_Available_Property_Unregulated.png';
import noHostPropertyApproved from '../../images/No_Host_Property_Approved.png';
import noHostPropertyBanned from '../../images/No_Host_Property_Banned.png';
import noHostPropertyUnregulated from '../../images/No_Host_Property_Unregulated.png';

const MapMarker = ({ location, onEnquireClick, regulationStatuses }) => {
  const [isInfoOpen, onInfoChange] = useState(false);
  const onMarkerClick = () => onInfoChange(!isInfoOpen);
  return (
    <Marker
      key={location.id}
      position={{ lat: location.latitude, lng: location.longitude }}
      onClick={onMarkerClick}
      defaultIcon={{
        url:
          location.propertyStatus === 'approved' && (location.host.verified || location.host.unverified) // TODO: Find a better way for hard-coded constants
            ? hostAvailablePropertyApproved
            : location.propertyStatus === 'banned' && (location.host.verified || location.host.unverified) // TODO: Find a better way for hard-coded constants
            ? hostAvailablePropertyBanned
            : location.propertyStatus === 'unregulated' && (location.host.verified || location.host.unverified) // TODO: Find a better way for hard-coded constants
            ? hostAvailablePropertyUnregulated
            : location.propertyStatus === 'approved' && !location.host.verified && !location.host.unverified // TODO: Find a better way for hard-coded constants
            ? noHostPropertyApproved
            : location.propertyStatus === 'banned' && !location.host.verified && !location.host.unverified // TODO: Find a better way for hard-coded constants
            ? noHostPropertyBanned
            : noHostPropertyUnregulated,
        scaledSize: new window.google.maps.Size(48, 48)
      }}
    >
      {isInfoOpen && (
        <InfoWindow onCloseClick={onMarkerClick}>
          <LocationCard
            title={location.propertyName}
            body={`${location.host.verified} Verified host, ${location.host.unverified} Unverified host`}
            hostStatus={getStatus(location.propertyStatus, regulationStatuses)}
            onEnquireClick={onEnquireClick}
          />
        </InfoWindow>
      )}
    </Marker>
  );
};

const getStatus = (status, regulationStatuses) => {
  const foundStatus = regulationStatuses.find(curStatus => curStatus.code === status);
  return foundStatus.label;
};

export const BareGoogleMap = ({ properties, innerRef, center, zoom, onPropertyEnquireClick, ...otherProps }) => {
  const { selections: regulationStatuses } = useFetchConstant('buildingRegulationStatuses');
  return (
    <GoogleMap ref={innerRef} defaultZoom={8} defaultCenter={DEFAULT_MAP_LOCATION} zoom={zoom} center={center} {...otherProps}>
      {center && <Marker position={center} />}
      <MarkerClusterer averageCenter enableRetinaIcons gridSize={60} maxZoom={12}>
        {properties.map(property => {
          return (
            <MapMarker
              key={property.id}
              location={property}
              onEnquireClick={() => onPropertyEnquireClick(property.id)}
              regulationStatuses={regulationStatuses}
            />
          );
        })}
      </MarkerClusterer>
    </GoogleMap>
  );
};

BareGoogleMap.defaultProps = {
  center: DEFAULT_MAP_LOCATION,
  zoom: 8,
  onPropertyEnquireClick: () => {}
};

const UnstyledGoogleMap = withGoogleMap(props => <BareGoogleMap {...props} />);
UnstyledGoogleMap.displayName = 'GoogleMap';

export default UnstyledGoogleMap;
